import { PayloadAction } from '@reduxjs/toolkit';

import { WritableAutoConfiguratorState } from '../slice';

type CalculationRequestPayload = {
  lineItemUuid: string;
  requestId: string;
};

export function setPendingCalculationRequestId(
  state: WritableAutoConfiguratorState,
  action: PayloadAction<CalculationRequestPayload>,
) {
  const { lineItemUuid, requestId } = action.payload;

  state.pendingCalculationRequestIdByLineItemUuid[lineItemUuid] = requestId;
}

export function clearPendingCalculationRequestId(
  state: WritableAutoConfiguratorState,
  action: PayloadAction<CalculationRequestPayload>,
) {
  const { lineItemUuid, requestId } = action.payload;

  if (
    state.pendingCalculationRequestIdByLineItemUuid[lineItemUuid] !== requestId
  ) {
    return;
  }

  delete state.pendingCalculationRequestIdByLineItemUuid[lineItemUuid];
}

export function setLastSaveDateTime(
  state: WritableAutoConfiguratorState,
  action: PayloadAction<Date | null>,
) {
  state.lastSaveDateTime = action.payload;
}
